import React from 'react';
import { observer } from 'mobx-react';
import * as local from '../../../helpers/localStorage';
import { MTG_UPCOMING, MTG_PREVIOUS, MTG_DRAFT, MTG_VIEW_LIST } from '../../../helpers/constants';
import * as utils from '../../../helpers/utils';
import MeetingCard from './components/MeetingCard';

import store from '../../../stores/store';

const MeetingPanel = observer(
    class MeetingPanel extends React.Component {
        renderHeader = () => {
            const upcomingSelected = store.meetings.filteredBy === MTG_UPCOMING ? 'active' : '';
            const previousSelected = store.meetings.filteredBy === MTG_PREVIOUS ? 'active' : '';
            const draftSelected = store.meetings.filteredBy === MTG_DRAFT ? 'active' : '';

            const badgeCounts = local.countMeetingFilterBadges();
            // const upcomingCount = badgeCounts.upcomingCount;
            const upcomingUnread = badgeCounts.upcomingUnread;
            const previousCount = badgeCounts.previousCount;
            const previousUnread = badgeCounts.previousUnread;
            const draftCount = badgeCounts.draftCount;
            const draftUnread = badgeCounts.draftUnread;

            return (
                <div className="row align-items-center mb-3">
                    <div className="col ml-3">
                        <h6>Meetings</h6>
                    </div>

                    <div
                        className="col-auto"
                        data-toggle="buttons"
                        role="group"
                        aria-label="Meeting cards options"
                        id="meetings-cards"
                    >
                        {/* <!-- Meeting Nav tabs --> */}
                        <div className="btn-group pl-3 mr-3" role="tablist">
                            <a
                                className={`btn btn-outline-secondary ${upcomingSelected}`}
                                data-toggle="tab"
                                onClick={() => store.meetings.toggleFilter(MTG_UPCOMING)}
                                role="tab"
                            >
                                Upcoming
                                {upcomingUnread > 0 ? (
                                    <span className="badge badge-pill badge-notify">
                                        {upcomingUnread}
                                    </span>
                                ) : null}
                            </a>
                            {previousCount > 0 ? (
                                <a
                                    className={`btn btn-outline-secondary ${previousSelected}`}
                                    data-toggle="tab"
                                    onClick={() => store.meetings.toggleFilter(MTG_PREVIOUS)}
                                    role="tab"
                                >
                                    Previous
                                    {previousUnread > 0 ? (
                                        <span className="badge badge-pill badge-notify">
                                            {previousUnread}
                                        </span>
                                    ) : null}
                                </a>
                            ) : null}
                            {draftCount > 0 ? (
                                <a
                                    className={`btn btn-outline-secondary ${draftSelected}`}
                                    data-toggle="tab"
                                    onClick={() => store.meetings.toggleFilter(MTG_DRAFT)}
                                    role="tab"
                                >
                                    Draft
                                    {draftUnread > 0 ? (
                                        <span className="badge badge-pill badge-notify">
                                            {draftUnread}
                                        </span>
                                    ) : null}
                                </a>
                            ) : null}
                        </div>
                    </div>
                </div>
            );
        };

        getLogo = instanceId => {
            const coIndex = store.companies.indexFromId(instanceId);
            if (typeof store.companies.logos[coIndex] !== 'undefined') {
                const logo =
                    store.companies.logos.length > 0 ? store.companies.logos[coIndex].url : '';
                return logo;
            }
            return '';
        };

        selectMeeting(instanceId, groupId, meetingId, history) {
            // select the meeting
            store.meetings.select(meetingId);

            //mark the meeeting as read
            local.setMeetingAsRead(instanceId, groupId, meetingId, utils.getNowInUtc());

            if (store.groups.selectedId === null) {
                const index = store.companies.indexFromId(instanceId);
                store.groups.toggleSelected(groupId, index);
            }

            //now redirect
            history.push('/dashboard/meetings/agenda');
        }

        componentWillReceiveProps() {
            switch (store.meetings.filteredBy) {
                case MTG_PREVIOUS:
                    if (store.meetings.meetingsFilteredByPrevious.length === 0) {
                        store.meetings.toggleFilter(MTG_UPCOMING);
                    }
                    break;

                case MTG_DRAFT:
                    if (store.meetings.meetingsFilteredByDraft.length === 0) {
                        store.meetings.toggleFilter(MTG_UPCOMING);
                    }
                    break;

                default:
                    break;
            }
        }

        render() {
            let filteredList = [];

            switch (store.meetings.filteredBy) {
                case MTG_UPCOMING:
                    filteredList = store.meetings.meetingsFilteredByUpcoming;
                    break;

                case MTG_PREVIOUS:
                    filteredList = store.meetings.meetingsFilteredByPrevious;
                    break;

                case MTG_DRAFT:
                    filteredList = store.meetings.meetingsFilteredByDraft;
                    break;

                default:
                    filteredList = store.meetings.meetingsFilteredByUpcoming;
            }

            if (store.meetings.displayMeetingTab) {
                return (
                    <div>
                        {this.renderHeader()}
                        <div className="tab-content" id="meeting-cards">
                            <div
                                className="tab-pane active"
                                role="tabpanel"
                                id={store.meetings.filteredBy}
                            >
                                <div className="row">
                                    {filteredList.length > 0 ? (
                                        filteredList.map((detail, i) => (
                                            <MeetingCard
                                                viewType={MTG_VIEW_LIST}
                                                key={i}
                                                i={i}
                                                selectMeeting={this.selectMeeting}
                                                history={this.props.history}
                                                details={detail}
                                                logo={this.getLogo(detail.InstanceId)}
                                                meetingPanelRerender={this.forceUpdate.bind(this)}
                                            />
                                        ))
                                    ) : (
                                        <div className="col-12 mb-3">
                                            <div className="card">
                                                <div className="card-block">
                                                    <p>
                                                        You have no {store.meetings.filteredBy}{' '}
                                                        meetings.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            } else {
                return null;
            }
        }
    },
);

export default MeetingPanel;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Meeting/MeetingPanel.js